import { IDropDownArray } from "src/types/GlobalInterfaces";

export type cityName = "karachi" | "lahore" | "faisalabad" | "rawalpindi" | "multan" | "hyderabad" | "gujranwala" | "peshawar" | "quetta" | "islamabad" | "bahawalpur" | "sialkot";

const obj: Record<cityName, string> = {
    karachi: "Karachi",
    lahore: "Lahore",
    faisalabad: "Faisalabad",
    rawalpindi: "Rawalpindi",
    multan: "Multan",
    hyderabad: "Hyderabad",
    gujranwala: "Gujranwala",
    peshawar: "Peshawar",
    quetta: "Quetta",
    islamabad: "Islamabad",
    bahawalpur: "Bahawalpur",
    sialkot: "Sialkot",
};

// Dubai/UAE Cities (commented)
// export const cityList: IDropDownArray[] = [
//     { label: "Abu Dhabi", value: "abu_dhabi" },
//     { label: "Dubai", value: "dubai" },
//     { label: "Sharjah", value: "sharjah" },
//     { label: "Ajman", value: "ajman" },
//     { label: "Ras Al Khaimah", value: "ras_al_khaimah" },
//     { label: "Fujairah", value: "fujairah" },
//     { label: "Umm Al Quwain", value: "umm_al_quwain" },
//     { label: "Al Ain", value: "al_ain" },
//     { label: "Dibba", value: "dibba" },
//     { label: "Khor Fakkan", value: "khor_fakkan" }
// ];

// Pakistan Main Cities
export const cityList: IDropDownArray[] = [
  // Sindh
  { label: "Karachi", value: "karachi" },
  { label: "Hyderabad", value: "hyderabad" },
  { label: "Sukkur", value: "sukkur" },
  { label: "Larkana", value: "larkana" },
  { label: "Nawabshah", value: "nawabshah" },
  { label: "Mirpur Khas", value: "mirpur_khas" },
  { label: "Jacobabad", value: "jacobabad" },
  { label: "Khairpur", value: "khairpur" },
  { label: "Shikarpur", value: "shikarpur" },
  { label: "Thatta", value: "thatta" },
  { label: "Badin", value: "badin" },
  { label: "Dadu", value: "dadu" },
  { label: "Umerkot", value: "umerkot" },
  // Punjab
  { label: "Lahore", value: "lahore" },
  { label: "Faisalabad", value: "faisalabad" },
  { label: "Rawalpindi", value: "rawalpindi" },
  { label: "Multan", value: "multan" },
  { label: "Gujranwala", value: "gujranwala" },
  { label: "Sialkot", value: "sialkot" },
  { label: "Bahawalpur", value: "bahawalpur" },
  { label: "Sargodha", value: "sargodha" },
  { label: "Sheikhupura", value: "sheikhupura" },
  { label: "Rahim Yar Khan", value: "rahim_yar_khan" },
  { label: "Gujrat", value: "gujrat" },
  { label: "Jhang", value: "jhang" },
  { label: "Kasur", value: "kasur" },
  { label: "Okara", value: "okara" },
  { label: "Vehari", value: "vehari" },
  { label: "Khanewal", value: "khanewal" },
  { label: "Mianwali", value: "mianwali" },
  { label: "Dera Ghazi Khan", value: "dera_ghazi_khan" },
  { label: "Chiniot", value: "chiniot" },
  { label: "Hafizabad", value: "hafizabad" },
  { label: "Pakpattan", value: "pakpattan" },
  { label: "Lodhran", value: "lodhran" },
  { label: "Narowal", value: "narowal" },
  { label: "Toba Tek Singh", value: "toba_tek_singh" },
  // Khyber Pakhtunkhwa (KPK)
  { label: "Peshawar", value: "peshawar" },
  { label: "Mardan", value: "mardan" },
  { label: "Abbottabad", value: "abbottabad" },
  { label: "Mingora (Swat)", value: "mingora" },
  { label: "Dera Ismail Khan", value: "dera_ismail_khan" },
  { label: "Kohat", value: "kohat" },
  { label: "Bannu", value: "bannu" },
  { label: "Charsadda", value: "charsadda" },
  { label: "Nowshera", value: "nowshera" },
  { label: "Mansehra", value: "mansehra" },
  { label: "Haripur", value: "haripur" },
  { label: "Swabi", value: "swabi" },
  { label: "Karak", value: "karak" },
  { label: "Hangu", value: "hangu" },
  { label: "Battagram", value: "battagram" },
  // Balochistan
  { label: "Quetta", value: "quetta" },
  { label: "Gwadar", value: "gwadar" },
  { label: "Turbat", value: "turbat" },
  { label: "Khuzdar", value: "khuzdar" },
  { label: "Chaman", value: "chaman" },
  { label: "Sibi", value: "sibi" },
  { label: "Zhob", value: "zhob" },
  { label: "Lasbela", value: "lasbela" },
  { label: "Pasni", value: "pasni" },
  { label: "Panjgur", value: "panjgur" },
  // Azad Jammu & Kashmir
  { label: "Muzaffarabad", value: "muzaffarabad" },
  { label: "Mirpur", value: "mirpur" },
  { label: "Kotli", value: "kotli" },
  { label: "Bhimber", value: "bhimber" },
  { label: "Rawalakot", value: "rawalakot" },
  { label: "Bagh", value: "bagh" },
  // Gilgit-Baltistan
  { label: "Gilgit", value: "gilgit" },
  { label: "Skardu", value: "skardu" },
  { label: "Hunza", value: "hunza" },
  { label: "Ghizer", value: "ghizer" },
  { label: "Diamer", value: "diamer" },
  { label: "Ghanche", value: "ghanche" },
  { label: "Astore", value: "astore" },
  // Capital Territory
  { label: "Islamabad", value: "islamabad" },
];

export const printCity = (city: cityName): string => {
    return obj[city] || ""
};